var _rect, _rect2, _rect3, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOfIran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 630,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 360,
    fill: "#da0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 240,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 120,
    fill: "#239f40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4,100.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tb4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tb1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "tbp1",
    d: "M0,1H26M1,10V5H9V9H17V5H12M4,9H6M26,9H21V5H29M29,0V9H37V0M33,0V9",
    transform: "scale(1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tbp2",
    d: "M0,7H9M10,7H19",
    transform: "scale(2.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tbp2",
    y: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tbp1",
    y: 145.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "tb3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 168
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb3",
    x: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb4",
    x: 392
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#da0000",
    transform: "matrix(45,0,0,45,315,180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emblem_half"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.015679,-0.01556 A 0.77528237,0.7752862 0 0 1 0.60199011,0.67052066 1.0040699,1.0040749 0 0 0 0.44435035,-0.74067818 q -0.0221518,-0.0177005 -0.0452767,-0.0341288 A 0.77575926,0.7757631 0 0 1 1.015679,-0.01556 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.65590144,-0.04683837 a 0.92689013,0.92689472 0 0 1 -1.21301321,0.88105983 q 0.0245198,0.00118 0.0492749,0.001178 a 1.0158759,1.0158809 0 0 0 0.84183925,-1.58419413 0.92423346,0.92423804 0 0 1 0.32189906,0.7019563 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.26154437,-0.94393072 A 0.14154065,0.14154135 0 0 1 1.7299476e-6,-0.86887791 L -0.01707249,-0.88602911 1.7299476e-6,-0.96931462 A 0.1321491,0.13214975 0 0 0 0.24983482,-1.0002001 a 0.14021999,0.14022068 0 0 1 0.0117096,0.0562694 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.11992727,-0.71445117 A 0.31475286,0.31475442 0 0 1 1.2855032e-6,-0.81025163 L -0.0506876,-0.01642556 1.2855032e-6,1.0001998 0.07882572,0.89166862 0.0891995,0.64144186 0.09996594,0.3809197 l 0.0014156,-0.0334002 4.7111e-4,-0.0124172 0.002279,-0.0541474 0.006758,-0.1640148 0.005501,-0.13242286 0.001571,-0.03827263 0.002042,-0.04872535 V -0.71445117 Z M 1.2855032e-6,-0.54965037 9.0174383e-5,-0.54949481 1.2855032e-6,-0.54933925 Z m 0,0.86447753 V 0.3145916 L 3.946188e-4,0.31468049 Z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#emblem_half",
    transform: "scale(-1,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfIran);
export default __webpack_public_path__ + "static/media/Flag_of_Iran.8ac7b00af77ec8fab4e645885b3006e3.svg";
export { ForwardRef as ReactComponent };